import { memo, useMemo } from 'react';

import { H6 } from '@repo/ui-kit/components/core/Typography';

import { useUrlWithWorkspacePrefix } from 'global/utils/workspace/useUrlWithWorkspacePrefix';

import { NavigationMenuButton } from '../../NavigationMenuButton';
import { useSidebar } from '../../SidebarProvider';
import { NavigationMenuSubMenuItemProps } from '../types';
import { isActiveOverriden, isUrlMatch } from '../utils';

export const NavigationMenuSubMenuItem = memo<NavigationMenuSubMenuItemProps>(
  ({ label, href, hrefPrefixedByWorkspace, isSubMenuOpen, activeUrls }) => {
    const { optimisticPath } = useSidebar();
    const resolvedHref = useUrlWithWorkspacePrefix({
      href,
      ignorePrefix: !hrefPrefixedByWorkspace,
    });

    // We use the optimistic path to check if menu should be open
    const isSectionActive = useMemo(
      () =>
        Boolean(
          resolvedHref &&
            (isUrlMatch(optimisticPath, resolvedHref) ||
              isActiveOverriden(optimisticPath, activeUrls))
        ),
      [optimisticPath, resolvedHref, activeUrls]
    );

    return (
      <li>
        <NavigationMenuButton
          href={resolvedHref}
          isActive={isSectionActive}
          tabIndex={isSubMenuOpen ? 0 : -1}
        >
          <H6 as="span" color="secondary">
            {label}
          </H6>
        </NavigationMenuButton>
      </li>
    );
  }
);

NavigationMenuSubMenuItem.displayName = 'NavigationMenuSubMenuItem';
